<template>
  <oms-filter-content :title="title || t('features.vue.orders.filters.plan')" :is-filtering='isFilteringTypes || isFilteringPeriods'>
    <div class='mr-2' v-show='isFilteringTypes'>
      <span v-for='planType in selectedPlanTypes?.include' class='badge badge-info position-static mr-1'>
        {{ planTypes[planType] }}
      </span>
    </div>

    <div v-show='isFilteringPeriods'>
      <span v-for='duration in selectedPlanPeriods?.include' class='badge badge-secondary position-static mr-1'>
        {{ planPeriods[duration] }}
      </span>
    </div>
  </oms-filter-content>
</template>

<script>
import OmsFilterContent from '../filter-content.vue'

export default {
  inject: ['i18n'],

  props: {
    title: String,
    planTypes: Object,
    planPeriods: Object,
    selectedPlanTypes: Object,
    selectedPlanPeriods: Object
  },

  computed: {
    isFilteringTypes() {
      return this.selectedPlanTypes?.include?.length > 0
    },

    isFilteringPeriods() {
      return this.selectedPlanPeriods?.include?.length > 0
    }
  },

  methods: {
    t(key, options) {
      return this.i18n ? this.i18n.t(key, options) : key
    }
  },

  components: {
    OmsFilterContent
  }
}
</script>
